<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <v-container>
          <v-row>
            <v-col md="12" lg="3">
              <v-container>
                <v-row class="overview-column">
                  <v-col>
                    <h4 color="primary"> {{ $t('book/issue:overview-form.overview') }} </h4>
                    <v-expansion-panels
                        tile
                        flat
                        multiple
                        v-model="expansionModel"
                        accordion>
                      <v-expansion-panel
                          v-for="(item,i) in viewPanel"
                          :key="i"
                      >
                        <v-expansion-panel-header
                            color="#f3f3f3"
                            class="text-center expansion-header"
                            hide-actions>{{ item.name }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-if="item.id === 'task'">
                            {{ taskInfo.name }}
                          </div>
                          <div v-if="item.id === 'common-data'">
                            {{ taskInfo.description }}
                          </div>
                          <div v-if="item.id === 'address'">
                            <b>{{$t('common:street')}}:</b> {{ facility.buildingStreet }} <br/>
                            <b>{{$t('common:city')}}:</b> {{ facility.buildingCity }} <br/>
                            <b>{{$t('common:zip')}}:</b> {{ facility.buildingZip }} <br/>
                          </div>
                          <div v-if="item.id === 'facility-info'">
                            <b>{{$t('common:name')}}: </b> {{facility.name}} <br/>
                            <b>{{$t('common:facility-type')}}: </b> {{facility.typeName}}
                          </div>
                          <div v-if="item.id === 'contact-person' && contactInfo" class="v-list-item v-list-item--link theme--light">
                            <v-avatar size="40">
                              <v-img
                                  src="@/assets/default_profile_pic.png"
                              ></v-img>
                            </v-avatar>
                            <v-row class="ml-2" align="center">
                              <v-col cols="8">
                                <span>{{ contactInfo.name }} </span>
                              </v-col>
                              <v-col cols="4" class="text-right">
                                <v-btn class="contact-icon" color="primary" v-if="contactInfo.phone" icon @click="callPhoneNumber(contactInfo.phone)">
                                  <v-icon>phone</v-icon>
                                </v-btn>
                                <v-btn class="contact-icon" color="primary" v-if="contactInfo.email" icon @click="writeEmail(contactInfo.email)">
                                  <v-icon>mail</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                          <v-col v-if="item.id === 'board-column'">
                            <v-select outlined
                                      :label="$t('book/issue:common.board-column')"
                                      item-value="code"
                                      item-text="label"
                                      @change="updateBoardStatus"
                                      v-model="taskInfo.boardStatus"
                                      :items="boardColumn" />
                          </v-col>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn v-if="!facilityWindow" outlined color="primary" class="facility-button" @click="goToFacility">
                      {{ $t('buttons:open-specific', {specific: $t('common:facility')}) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col md="12" lg="9">
              <v-container>
                <v-row>
                  <v-col>
                    <v-breadcrumbs
                      :items="crumbs"
                      large
                      class="primary--text"
                    ></v-breadcrumbs>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-tabs
                      v-model="tab"
                      align-with-title
                      class="main-content-tab"
                    >
                      <v-tabs-slider color="yellow"></v-tabs-slider>
                      <v-tab
                        v-for="tab in tabs"
                        :key="tab.id"
                      >
                        {{ tab.name }}
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        v-for="item in tabs"
                        :key="item.id"
                      >
                        <GeneralTab
                          v-if="item.id === 'common-data'"
                          :task-info = "taskInfo"
                          :task-status = "taskStatus"
                          :is-task-finished="isTaskFinished"
                          @callUpdateData = "updateData()"
                          :couldTaskBeProcessed="couldTaskBeProcessed && !taskStatus.OFFER_REQUEST"
                          ref="common-data"
                        />
                        <DocumentTab
                          v-if="item.id === 'document'"
                          :task-info = "taskInfo"
                          @updateData="updateData()"
                          :is-task-finished="isTaskFinished"
                          card-view
                          ref="document"
                        />
                        <InvoiceTab
                          v-if="item.id === 'invoice'"
                          :task-info = "taskInfo"
                          @updateData="updateData()"
                          :is-task-finished="isTaskFinished"
                          ref="invoice"
                        />
                        <OrderTab
                          v-if="item.id === 'order'"
                          :task-info = "taskInfo"
                          @updateData="updateData()"
                          :is-task-finished="isTaskFinished"
                          ref="order"
                        />
                        <OfferTab
                          v-if="item.id === 'offer'"
                          :task-info = "taskInfo"
                          :facility = "facility"
                          :is-task-finished="isTaskFinished"
                          ref="offer"
                          @updateData="updateData()"
                        />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import DocumentTab from '@/modules/book/views/task/dialog-components/DocumentTab.vue';
import GeneralTab from '@/modules/book/views/task/dialog-components/GeneralTab.vue';
import InvoiceTab from '@/modules/book/views/task/dialog-components/InvoiceTab.vue';
import OfferTab from '@/modules/book/views/task/dialog-components/OfferTab.vue';
import TaskBoardService from '@/modules/book/services/task-board-service';
import FacilityService from '@/modules/book/services/facility-service';
import UsersService from '@/modules/core/services/users-service';
import Utils from '@/modules/core/services/utils';
import ContractInfoService from '@/modules/book/services/contract-info-service';
import NameColumn from '@/modules/book/views/task/name-column';
import OrderTab from '@/modules/book/views/task/dialog-components/OrderTab.vue';

export default {
  name: 'ViewTaskDialog',
  components: {OrderTab, OfferTab, InvoiceTab, DocumentTab, GeneralTab},
  props: {
    facilityWindow: Boolean
  },
  data() {
    return {
      dialog: false,
      tab: null,
      taskInfo: {},
      taskStatus: null,
      contactInfo: null,
      facility: {},
      user: {},
      contractInfo: {},
      expansionModel: [0, 1, 2, 3, 4, 5]
    }
  },
  computed: {
    crumbs() {
      if (!this.taskStatus) return [];
      let crumbs = this.couldTaskBeProcessed ?
          [
            { text: this.$t('book/issue:bread-crumbs.new'), disabled: false, code: 'TASK_NEW'},
            { text: this.$t('book/issue:bread-crumbs.order-created'), disabled: !this.taskStatus.CREATE_ORDER, code: 'CREATE_ORDER' },
            { text: this.$t('book/issue:bread-crumbs.order-finished'), disabled: !this.taskStatus.FINISH_ORDER, code: 'FINISH_ORDER' },
            { text: this.$t('book/issue:bread-crumbs.success'), disabled: !this.isTaskFinished, code: 'SUCCESS_TASK' }
          ]
          : [
            { text: this.$t('book/issue:bread-crumbs.new'), disabled: false, code: 'TASK_NEW' },
            { text: this.$t('book/issue:bread-crumbs.offer-requested'), disabled: !this.taskStatus.OFFER_REQUEST, code: 'OFFER_ADD' },
            { text: this.$t('book/issue:bread-crumbs.offer-accepted'), disabled: !this.taskStatus.OFFER_SIGN, code: 'OFFER_SIGN' },
            { text: this.$t('book/issue:bread-crumbs.order-created'), disabled: !this.taskStatus.CREATE_ORDER, code: 'CREATE_ORDER' },
            { text: this.$t('book/issue:bread-crumbs.order-finished'), disabled: !this.taskStatus.FINISH_ORDER, code: 'FINISH_ORDER' },
            { text: this.$t('book/issue:bread-crumbs.invoice-requested'), disabled: !this.taskStatus.INVOICE_REQUEST, code: 'INVOICE_ADD' },
            { text: this.$t('book/issue:bread-crumbs.invoice-sent'), disabled: !this.taskStatus.INVOICE_SEND, code: 'INVOICE_SEND' },
            { text: this.$t('book/issue:bread-crumbs.success'), disabled: !this.isTaskFinished, code: 'SUCCESS_TASK' }
          ];
      for(let i = 0; i < crumbs.length; i++) {
        if (crumbs[i].code === this.taskInfo.boardStatus) {
          crumbs[i].activeClass = 'board-status-class';
          crumbs[i].disabled = true;
        }
      }
      return crumbs;
    },
    viewPanel() {
      return [
        {id: "task", name: this.$t('book/issue:common.task')},
        {id: "common-data", name: this.$t('book/issue:common.common-data')},
        {id: "address", name: this.$t('common:address')},
        {id: "contact-person", name: this.$t('book/issue:common.contact-person')},
        {id: "facility-info", name: this.$t('book/issue:common.facility-info')},
        {id: "board-column", name: this.$t('book/issue:common.board-column')}
      ]
    },
    tabs() {
      return [
        {id: 'common-data', name:this.$t('book/issue:common.common-data')},
        {id: 'offer', name:this.$t('book/issue:overview-form.offer')},
        {id: 'order', name:this.$t('book/issue:common.order')},
        {id: 'invoice', name:this.$t('book/issue:overview-form.invoice')},
        {id: 'document', name:this.$t('common:document_plural')}
      ]
    },
    boardColumn() {
      this.$t('');
      return NameColumn.getColumns();
    },
    couldTaskBeProcessed() {
      if (!this.taskInfo
          || !this.taskStatus
          || !this.contractInfo
          || !this.contractInfo.types
          || !this.contractInfo.types.length === 0
          || this.taskInfo.vandalism
          || this.taskStatus.OFFER_REQUEST
          || this.taskStatus.OFFER_SIGN
          || this.taskStatus.INVOICE_REQUEST
          || this.taskStatus.INVOICE_SEND
      ) return false;

      let isFullMaintance = false;
      this.contractInfo.types.forEach(
        type => {
          if (type === 'FULL_MAINTENANCE') {
            isFullMaintance = true;
          }
        }
      );

      if (!isFullMaintance) return isFullMaintance;

      return this.taskInfo.category === 'REPAIR' || this.taskInfo.category === 'MALFUNCTION';
    },
    isTaskFinished() {
      return this.taskStatus && this.taskStatus.SUCCESS_TASK || this.taskInfo.deleted;
    },
  },
  methods: {
    openDialog(item) {
      this.dialog = true
      this.taskInfo = {};
      if (!item) {
        return;
      }
      this.taskInfo = item;

      this.loadFacilityInfo();
      this.loadBreadCrumbs();
      this.loadUserInfo();
      this.loadContractInfo();
      this.loadContactInfo()
    },
    closeDialog() {
      this.dialog = false;
      this.clearAllTabs();
      this.tab = null;
      this.taskInfo = {};
      this.taskStatus = null;
      this.facility = {};
      this.user = {};
      this.expansionModel = [0, 1, 2, 3, 4];
      this.$emit('closeDialog');
    },
    updateData() {
      if (!this.taskInfo) {
        return;
      }
      TaskBoardService.readTask(this.taskInfo.id,
        (response) =>{
          this.taskInfo = response.data;
          this.loadBreadCrumbs();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task')}));
        }
      );
    },
    clearAllTabs() {
      this.tabs.forEach((tab) => {
        if (this.$refs[tab.id]) {
          this.$refs[tab.id][0].clearData();
        }
      })
    },
    loadBreadCrumbs() {
      TaskBoardService.loadBreadCrumbs(
        this.taskInfo.id,
        (response) => {
          this.taskStatus = response.data;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:status')}));
        }
      )
    },
    loadFacilityInfo() {
      if (!this.taskInfo || !this.taskInfo.facility) return;

      FacilityService.readByIdFromAPI(
        this.taskInfo.facility,
        (responce) => {
          this.facility = responce.data;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility')}));
        }
      )
    },
    loadContactInfo() {
      this.contactInfo = null;
      UsersService.readFromAPI(
          this.taskInfo.contact,
          (response) => {
            this.setContactInfo(response.data);
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}));
          }
      );
    },
    loadUserInfo() {
      if (!this.taskInfo || !this.taskInfo.manager) return;

      UsersService.readFromAPI(
        this.taskInfo.manager,
        (response) => {
          this.user = response.data;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}));
        }
      )
    },
    loadContractInfo() {
      if (!this.taskInfo || !this.taskInfo.facility) return;

      ContractInfoService.readContractByFacility(
        this.taskInfo.facility,
        (response) => {
          this.contractInfo = response.data;
        }
      )
    },
    callPhoneNumber(phoneNumber) {
      window.open('tel:' + phoneNumber)
    },
    writeEmail(mail) {
      window.open('mailto:' + mail)
    },
    goToFacility() {
      let facilityUrl = this.$router.resolve({name: 'FacilityDashboardTab', params:{id: this.taskInfo.facility}});
      window.open(facilityUrl.href, '_blank');
    },
    updateBoardStatus(status) {
      TaskBoardService.updateBoardStatus(
          this.taskInfo.id,
          status,
          () => {
            this.$emit('updateTaskList')
          }
      );
    },
    setContactInfo(contact) {
      let contactInfo = {};
      if (contact && contact.id) {
        contactInfo.name = contact.name ? contact.name : null;
        contactInfo.email = contact.email ? contact.email : null;
        contactInfo.phone = contact.phone ? contact.phone : null;
      }

      if (!contactInfo.name || !contactInfo.email && !contactInfo.phone) {
        contactInfo.name = this.taskInfo.externalContact;
        contactInfo.phone = this.taskInfo.externalPhoneContact;
      }

      if (contactInfo.name && contactInfo.email || contactInfo.name && contactInfo.phone) {
        this.contactInfo = contactInfo;
      }
    }
  }
}
</script>

<style lang="scss">
.form-dialog {
  background: rgb(255, 255, 255, 1);

  .v-expansion-panel {
    margin-bottom: 5px;

    .expansion-header {
      padding: 16px 15px;
    }
  }

  .facility-button {
    width: 100%;
  }

  .overview-column {
    min-height: 500px;
    .v-expansion-panel-content__wrap {
      padding: 0 15px 15px;
    }
  }

  .contact-icon {
    margin: 0;
  }
}

.board-status-class{
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
}

.main-content-tab {
  .v-tab:first-child {
    margin-left: 0 !important;
  }
}

/*
  had to set z-index of dialog and overlay manually here
  because here we have a single case of dialog over dialog
*/
.v-dialog__content.v-dialog__content--active {
  z-index: 500 !important;
}

</style>